import React from 'react';
import styled from 'styled-components';

import { Button } from '~/atomic/atom/Button';
import Modal from '~/atomic/molecula/Modal';
import { useDisableAbonnementAutoRenewal } from '~/atomic/page/bookSubscriptions/abonnementPage.data';
import { PageTitleStyle, TextRegStyle } from '~/atomic/Typography';
import { lessThan } from '~/lib/mediaQuery';

type TProps = {
  price: number;
  isOpen: boolean;
  onClose: () => void;
};

export const DisableAbonnementDiscountModal: React.FC<TProps> = ({
  price,
  isOpen,
  onClose,
}: TProps) => {
  const { mutateAsync: disableAbonnementAuthRenewal, isLoading: isLoadingDisableAbonnementAuthRenewal } = useDisableAbonnementAutoRenewal();

  const cancelAutoRenewalDiscount = async () => {
    await disableAbonnementAuthRenewal();
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      width="550px"
      onCancel={onClose}
    >
      <SCTitle>
        Отключение абонемента
      </SCTitle>
      <SCContent>
        У вас сейчас действует специальная цена на абонемент
        {' '}
        <del>299₽</del>
        {' '}
        {price}
        ₽ в месяц.
        <br />
        <br />
        Вы действительно хотите отказаться от возможности читать много по низкой цене?
      </SCContent>
      <SCButtons>
        <SCButton
          block
          type="primary"
          size="large"
          onClick={onClose}
          disabled={isLoadingDisableAbonnementAuthRenewal}
        >
          Оставить абонемент
        </SCButton>
        <Button
          block
          size="large"
          onClick={cancelAutoRenewalDiscount}
          isLoading={isLoadingDisableAbonnementAuthRenewal}
        >
          Все равно отключить
        </Button>
      </SCButtons>
    </Modal>
  );
};

const SCTitle = styled.h3`
  ${PageTitleStyle};
  color: var(--black-color);
  margin-bottom: 12px;
`;

const SCContent = styled.div`
  ${TextRegStyle};
  color: var(--black-color);
`;

const SCButton = styled(Button)`
  min-width: max-content;

  ${lessThan('xs')} {
    max-width: none;
  }
`;

const SCButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 36px;
  margin-top: 40px;

  ${lessThan('xs')} {
    flex-direction: column;
    gap: 12px;
  }
`;
